/** Acreage the way a person writes it: 1 acre, 2.5 acres — never 1.0 acres. */
export const acresText = (n) => {
  const value = Number(n || 0);
  if (!Number.isFinite(value)) return String(n);
  return Number.isInteger(value) ? String(value) : String(Math.round(value * 1000) / 1000);
};

export const acresPhrase = (n) => {
  const text = acresText(n);
  return `${text} ${text === "1" ? "acre" : "acres"}`;
};
